import { render, staticRenderFns } from "./WorkspaceListFilter.vue?vue&type=template&id=5434b416&"
import script from "./WorkspaceListFilter.vue?vue&type=script&lang=js&"
export * from "./WorkspaceListFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports